export default __webpack_public_path__ + "static/media/work3.3a200125.svg";